(function () {
    'use strict';
    var controllerId = 'testSelect';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$uibModalInstance', 'datacontext', 'sectionMenu', "common", testSelect]);

    function testSelect($rootScope, $scope, $uibModalInstance, datacontext, sectionMenu, common, test) {
        $scope.item = {};
        $scope.item.fTesto = '';
        $scope.item.fAutore = 0;
        $scope.item.fCondiviso = 0;
        $scope.item.fTipologia = 0;
        $scope.item.test = [];
        $scope.tipoTest = [];

        $scope.item.pageSize = 30;
        $scope.item.page = 1;
        $scope.item.loading = false;

        getTipoTest();

        //Metodi su interfaccia
        $scope.item.cerca = cerca;
        $scope.item.loadMore = getAllByFilter;
        $scope.testSelected = testSelected;
        $scope.item.loadAll = getAll;

        //Elenco per Ordinamento
        $scope.item.list = {};
        $scope.item.list.ordine = ["Difficolta'", "Docente", "Materia", "Titolo", "Ultima Modifica"];
        $scope.item.list.ordine = common.setOrdine($scope.item.list.ordine);
        $scope.item.ordine = $scope.item.list.ordine[4];

        $scope.item.selectOrdine = function (item) {
            $scope.item.ordine = item;
            cerca();
        };
                
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        countByFilter();

        function cerca() {
            $scope.item.test = [];
            $scope.item.countRecords = 0;
            $scope.item.page = 1;
            if ($scope.item.fTipologia == null)
                $scope.item.fTipologia = 0;

            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            if ($scope.item.fAutore < 2) {
                return datacontext.testDocentiAllievi_countByFilter(3, $scope.item.fTesto, 0, $scope.item.fAutore, $scope.item.fTipologia)
                    .then(function (data) {
                        if (data) {                            
                            $scope.item.countRecords = data;
                        }
                    });
            }
            else if ($scope.item.fAutore == 3) { 
                return datacontext.testAcquistati_countByFilter($scope.item.fTesto)
                    .then(function (data) {
                        if (data) {
                            $scope.item.countRecords = data;
                        }
                    });
            }

            else {
                return datacontext.testCondivisi_countByFilter($scope.item.fTesto, $scope.item.fTipologia, $rootScope.community)
                .then(function (data) {
                    if (data) {
                        $scope.item.countRecords = data;
                    }
                });
            }
        }

        function getAllByFilter() {             
            if ($scope.item.loading === true) return;
            if ($scope.item.countRecords == 0) countByFilter();
            else if ($scope.item.countRecords <= $scope.item.test.length) return;

            $scope.item.loading = true;

            if ($scope.item.fAutore < 2) {
                return datacontext.testDocentiAllievi_getAllByFilter($scope.item.pageSize, $scope.item.page, 3, $scope.item.fTesto, 0, $scope.item.fAutore, $scope.item.fTipologia, $scope.item.ordine.value)
                    .then(function (data) {
                        if (data.constructor === Array) {
                            $scope.item.page++;
                            data.forEach(function (item) {
                                $scope.item.test.push(item);
                            });
                        }
                    $scope.item.loading = false;
                });
            }
            else if ($scope.item.fAutore == 3) { 
                return datacontext.testAcquistati_getAllByFilter($scope.item.pageSize, $scope.item.page, $scope.item.fTesto, $scope.item.ordine.value)
                    .then(function (data) {
                        if (data.constructor === Array) {
                            $scope.item.page++;
                            data.forEach(function (item) {
                                $scope.item.test.push(item);
                            });
                        }
                        $scope.item.loading = false;
                    });
            }
            else {
                return datacontext.testCondivisi_getAllByFilter($scope.item.pageSize, $scope.item.page, $scope.item.fTesto, $scope.item.fTipologia, $rootScope.community, $scope.item.ordine.value)
                    .then(function (data) {
                        if (data.constructor === Array) {
                            $scope.item.page++;
                            data.forEach(function (item) {
                                $scope.item.test.push(item);
                            });
                        }
                        $scope.item.loading = false;
                    });
            }           
        }

        function getAll() {
            if ($scope.item.test.length < $scope.item.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function testSelected(id, title, questionsCount) {
            var result = {};
            result.id = id;
            result.title = title;
            result.questionsCount = questionsCount;

            $uibModalInstance.close(result);
        }

        function getTipoTest() {
            return datacontext.tipoTest_getAllList().then(function (data) {
                return $scope.tipoTest = data;
            });
        }
    }
})();